import { LinkAction } from '@leverege/molten/routes';
import { Config } from '@leverege/plugin';
import { GlobalState } from '@leverege/ui-redux';
import OpenApiGroupDelegate from "../../delegates/openApi/OpenApiGroupDelegate.js";
export default ({
  id,
  relationship,
  isRoot
}) => LinkAction.create({
  id,
  layout: Config.get(id, 'layout', {
    sort: relationship.getTagStartingWith('navSort:', true) || 'zzz',
    sectionName: relationship.getString('navSectionName')
  }),
  matches: isRoot ? {
    use: 'navBar',
    client: 'Main'
  } : {
    use: 'navBar',
    client: 'ItemScreen',
    path: relationship.parentRelationship.path
  },
  isPrepared: cxt => {
    const {
      clientProps: {
        match
      }
    } = cxt;
    const delegate = new OpenApiGroupDelegate({
      relationship: relationship.createResolved(match),
      match
    });
    return delegate.canList() != null;
  },
  prepare: cxt => {
    const {
      clientProps: {
        match
      }
    } = cxt;
    const delegate = new OpenApiGroupDelegate({
      relationship: relationship.createResolved(match),
      match
    });
    return GlobalState.dispatch(delegate.requestCanList());
  },
  handles: cxt => {
    const {
      clientProps: {
        match
      }
    } = cxt;
    const delegate = new OpenApiGroupDelegate({
      relationship: relationship.createResolved(match),
      match
    });
    return delegate.canList();
  },
  get name() {
    return relationship.name;
  },
  icon: relationship.getIcon('navIcon'),
  path: `/${relationship.urlPath}`
});